type Props = {
  children: React.ReactNode;
};

export const Title = ({ children }: Props) => {
  return <h1 className="text-[26px] font-light leading-normal">{children}</h1>;
};
